import React, { useState, useEffect, useRef } from 'react';
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Modal,
} from '@mui/material';
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import RouteMap from '../components/RouteMap';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import UsersCombo from '../components/UsersCombo';
import { api } from 'common';
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import { BookingModalBody, validateBookingObj } from 'common/sharedFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import { calcEst, showEst, optionsRequired } from '../common/sharedFunctions';
import CircularProgress from '@mui/material/CircularProgress';
import { MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions"
import { getLangKey } from 'common/src/other/getLangKey';

const { formatNumberInput, handleVietnameseNumberInput } = api;

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
    fontFamily: FONT_FAMILY
  },
  typography: {
    fontFamily: FONT_FAMILY,
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 480,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.BLACK}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  // dark variant for modal paper used for vehicle options
  paperDark: {
    width: 480,
    background: 'rgba(0,0,0,0.92)',
    color: colors.WHITE,
    border: `2px solid ${colors.BLACK}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
  marginTop: theme.spacing(2),
  backgroundColor: 'transparent',
  alignContent: 'center',
  borderRadius: "8px",
  width: '100%',
  maxWidth: 780,
  marginLeft: 'auto',
  marginRight: 'auto',
  boxSizing: 'border-box',
  padding: theme.spacing(0,2),

  },
  container1: {
  // booking panel background: subtle black gradient for a sleek look
  background: 'linear-gradient(180deg, #000000 0%, #111111 100%)',
  color: colors.WHITE,
  // force children text to white to avoid black-on-black styling from nested components
  '& *': {
    color: colors.WHITE + ' !important',
  },
  borderRadius: "12px",
  padding: '28px',
  width: '100%',
  top: "12px",
  boxShadow: `0px 8px 28px rgba(0,0,0,0.28)`,
  },
  // container specifically for the car type select to make it stand out
  carTypeContainer: {
    backgroundColor: colors.BLACK,
    padding: '10px',
    borderRadius: 8,
    '& *': {
      color: colors.WHITE + ' !important',
    }
  },
  title: {
  color: colors.WHITE,
  padding: '10px 14px',
  backgroundColor: MAIN_COLOR,
  fontFamily: FONT_FAMILY,
  borderRadius: "10px",
  fontSize: 18,

  },
  gridcontainer: {
    alignContent: 'center'
  },
  items: {
    margin: 0,
    width: '100%'
  },
  input: {
  fontSize: 16,
  color: colors.WHITE,
    fontFamily: FONT_FAMILY,
  },
  textFieldFull: {
    width: '100%'
  },
  formWrapper: {
    maxWidth: 720,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  inputdimmed: {
    fontSize: 18,
    color: colors.CARD_LABEL,
    fontFamily: FONT_FAMILY,
  },
  carphoto: {
    height: '28px',
    width: '40px',
    objectFit: 'cover',
    borderRadius: '4px',
    marginRight: '12px'
  },
  carphotoRtl: {
    height: '28px',
    width: '40px',
    objectFit: 'cover',
    borderRadius: '4px',
    marginLeft: '12px'
  },
  buttonStyle: {
    margin: 0,
  width: '100%',
  height: 44,
  borderRadius: "26px",
  backgroundColor: MAIN_COLOR,
  color: colors.BLACK,
  fontFamily: FONT_FAMILY,
  },
  buttonStyle1: {
    backgroundColor: MAIN_COLOR,
    fontFamily: FONT_FAMILY
  },
  buttonStyle2: {
    backgroundColor: SECONDORY_COLOR,
    fontFamily: FONT_FAMILY
  },
  // hero-style CTA to match QuickBooking visuals
  ctaButton: {
    borderRadius: 10,
    padding: '12px 22px',
    fontWeight: 800,
    background: 'linear-gradient(90deg, #D4AF37 0%, #B8860B 100%)',
    color: '#000',
    boxShadow: '0 8px 20px rgba(212,175,55,0.18)',
    textTransform: 'none',
    fontFamily: FONT_FAMILY,
  },
  secondaryButton: {
    borderRadius: 8,
    padding: '8px 18px',
    background: 'transparent',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.18)',
    fontFamily: FONT_FAMILY,
  },
  inputRtl: {
    "& label": {
      right: 25,
      left: "auto",
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 18,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  rightRty: {
    "& legend": {
      marginRight: 30,
      fontFamily: FONT_FAMILY,
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  textField: {
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  modalContent: {
    // ensure all text inside modal is white and inputs look like light glass
    color: colors.WHITE + ' !important',
    '& *': {
      color: colors.WHITE + ' !important',
      fontFamily: FONT_FAMILY,
    },
    '& .MuiOutlinedInput-root, & .MuiFilledInput-root, & .MuiInputBase-root': {
      backgroundColor: 'rgba(255,255,255,0.06) !important',
      borderRadius: 8,
      color: colors.WHITE + ' !important',
    },
    '& .MuiOutlinedInput-input, & .MuiInputBase-input, input, textarea': {
      color: colors.WHITE + ' !important',
    },
    '& .MuiFormLabel-root': {
      color: colors.WHITE + ' !important',
    },
    '& .MuiTypography-root': {
      color: colors.WHITE + ' !important',
    }
  },
}));

const icons = {
  'paypal': require('../assets/payment-icons/paypal-logo.png'),
  'braintree': require('../assets/payment-icons/braintree-logo.png'),
  'stripe': require('../assets/payment-icons/stripe-logo.png'),
  'payulatam': require('../assets/payment-icons/payulatam-logo.png'),
  'flutterwave': require('../assets/payment-icons/flutterwave-logo.png'),
  'paystack': require('../assets/payment-icons/paystack-logo.png'),
  'securepay': require('../assets/payment-icons/securepay-logo.png'),
  'payfast': require('../assets/payment-icons/payfast-logo.png'),
  'liqpay': require('../assets/payment-icons/liqpay-logo.png'),
  'culqi': require('../assets/payment-icons/culqi-logo.png'),
  'mercadopago': require('../assets/payment-icons/mercadopago-logo.png'),
  'squareup': require('../assets/payment-icons/squareup-logo.png'),
  'wipay': require('../assets/payment-icons/wipay-logo.png'),
  'test': require('../assets/payment-icons/test-logo.png'),
  'razorpay': require('../assets/payment-icons/razorpay-logo.png'),
  'paymongo': require('../assets/payment-icons/paymongo-logo.png'),
  'iyzico': require('../assets/payment-icons/iyzico-logo.png'),
  'slickpay': require('../assets/payment-icons/slickpay-logo.png'),
  'xendit': require('../assets/payment-icons/xendit-logo.png'),
  'tap': require('../assets/payment-icons/tap-logo.png')
}

export default function AddBookings(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  
  // Constante pour la valeur par défaut du sélecteur de véhicule
  const DEFAULT_CAR_SELECTION = 'select_car';
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    GetDistance,
    updateBooking,
    updateProfileWithEmail,
    checkUserExists,
  getDirectionsApi,
  fetchPlacesAutocomplete,
  fetchCoordsfromPlace
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const cartypes = useSelector(state => state.cartypes.cars);
  const estimatedata = useSelector(state => state.estimatedata);
  const bookingdata = useSelector(state => state.bookingdata);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const providers = useSelector(state => state.paymentmethods.providers);
  const activeBookings = useSelector(state => state.bookinglistdata.active);
  const [carType, setCarType] = useState(DEFAULT_CAR_SELECTION);
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [estimateModalStatus, setEstimateModalStatus] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  
  // Debug log for car selection
  useEffect(() => {
    console.log('🔍 Car Type State Changed:', { carType, selectedCarDetails });
  }, [carType, selectedCarDetails]);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [userCombo, setUserCombo] = useState(null);
  const [estimateRequested, setEstimateRequested] = useState(false);
  const [bookingType, setBookingType] = useState('Book Later');
  const rootRef = useRef(null);
  const [tempRoute, setTempRoute] = useState();
  const [drivers, setDrivers] = useState([]);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const { state } = useLocation();
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [roundTrip, setRoundTrip] = useState(0);
  const [tripInstructions, setTripInstructions] = useState('');
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [bookingOnWait, setBookingOnWait] = useState();
  const [deliveryWithBid, setDeliveryWithBid] = useState(0);
  const [otherPerson, setOtherPerson] = useState(false);
  const [offerFare, setOfferFare] = useState('');
  const [displayOfferFare, setDisplayOfferFare] = useState('');
  const [minimumPrice, setMinimumPrice] = useState(0);

  useEffect(() => {
    if (settings && settings.bookingFlow) {
      setDeliveryWithBid(settings.bookingFlow === "2" ? 1 : 0)
    }
  }, [settings, settings.bookingFlow])

  // Initialize and update display value for Vietnamese number formatting
  useEffect(() => {
    if (settings?.country === "Vietnam" && offerFare) {
      const displayValue = formatNumberInput(offerFare, true);
      setDisplayOfferFare(displayValue);
    } else {
      setDisplayOfferFare(offerFare);
    }
  }, [settings?.country, offerFare]);

  function formatAmount(value, decimal, country) {
    const number = parseFloat(value || 0);
    if (country === "Vietnam") {
      return number.toLocaleString("vi-VN", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    } else {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: decimal,
         maximumFractionDigits: decimal
       });
    }
  }

  const [instructionData, setInstructionData] = useState({
    otherPerson: "",
    otherPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    parcelTypeIndex: 0,
    optionIndex: 0,
    parcelTypeSelected: null,
    optionSelected: null
  });

  const [profileData, setProfileData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const [payment_mode, setPaymentMode] = useState(0);
  const [radioProps, setRadioProps] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (settings && providers) {
      setSelectedProvider(providers[0]);
      let arr = [{ label: t('wallet'), value: 0, cat: 'wallet' }];
      let val = 0;
      if (!settings.disable_online && providers && providers.length > 0) {
        val++;
        arr.push({ label: t('card'), value: val, cat: 'card' });
      }
      if (!settings.disable_cash) {
        val++;
        arr.push({ label: t('cash'), value: val, cat: 'cash' });
      }
      setRadioProps(arr);
    }
  }, [settings, providers, t]);;

  useEffect(() => {
    let quickBookingState = state;
    if ((!quickBookingState || quickBookingState === null) && typeof window !== 'undefined') {
      try {
        const storedQuickBooking = window.sessionStorage.getItem('pendingQuickBooking');
        quickBookingState = storedQuickBooking ? JSON.parse(storedQuickBooking) : null;
        if (quickBookingState) window.sessionStorage.removeItem('pendingQuickBooking');
      } catch (e) {}
    }

    if (quickBookingState && quickBookingState !== null) {
      // If route passed a carData (from direct booking), use it
      if (quickBookingState.carData) {
        let carDetails = quickBookingState.carData;
        setCarType(carDetails.name)
        setInstructionData({
          deliveryPerson: "",
          deliveryPersonPhone: "",
          pickUpInstructions: "",
          deliveryInstructions: "",
          parcelTypeIndex: 0,
          optionIndex: 0,
          parcelTypeSelected: Array.isArray(carDetails.parcelTypes) ? carDetails.parcelTypes[0] : null,
          optionSelected: Array.isArray(carDetails.options) ? carDetails.options[0] : null
        })
        setSelectedCarDetails(carDetails);
      }

      // If hero quick-book passed pickup/drop text, try to resolve them and trigger booking flow
      const quickPickup = quickBookingState.pickupText;
      const quickDrop = quickBookingState.dropText;
      const quickPickupSel = quickBookingState.pickupSel;
      const quickDropSel = quickBookingState.dropSel;
      const quickCarData = quickBookingState.carData;
        const quick = quickBookingState.quickBook;

      const resolvePlace = async (input) => {
        try {
          if (!input) return null;
          // If input already looks like a selection object with coords, return as-is
          if (typeof input === 'object') {
            if (input.coords && input.coords.lat && input.coords.lng) return input;
            if (input.place_id) {
              const coords = await fetchCoordsfromPlace(input.place_id).catch(() => null);
              return { description: input.description || input.label || '', place_id: input.place_id, coords: coords };
            }
            if (input.lat && input.lon) {
              // Normalize lat/lon to coords structure and remove lat/lon to avoid conflicts
              return { 
                description: input.description || '', 
                place_id: input.place_id || null, 
                coords: { lat: parseFloat(input.lat), lng: parseFloat(input.lon) },
                source: input.source || 'adresses'
              };
            }
            // otherwise fall through to text-based lookup
            input = input.description || input.label || '';
          }
          const results = await fetchPlacesAutocomplete(input, null).catch(() => null);
          if (results && results.length > 0) {
            const r = results[0];
            const coords = await fetchCoordsfromPlace(r.place_id).catch(() => null);
            return { description: r.description || input, place_id: r.place_id, coords: coords };
          }

          // Fallback: try the French government geocoder (api-adresse.data.gouv.fr)
          try {
            const url = `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(input)}&limit=1`;
            const resp = await (window.fetch ? window.fetch(url) : fetch(url));
            if (resp && resp.ok) {
              const json = await resp.json();
              const feat = (json.features || [])[0];
              if (feat) {
                const description = (feat.properties && feat.properties.label) ? feat.properties.label : input;
                const lat = feat.geometry && feat.geometry.coordinates ? feat.geometry.coordinates[1] : null;
                const lon = feat.geometry && feat.geometry.coordinates ? feat.geometry.coordinates[0] : null;
                if (lat && lon) {
                  return { 
                    description, 
                    place_id: `adresses_${(feat.properties && feat.properties.id) || feat.id}`, 
                    coords: { lat, lng: lon },
                    source: 'adresses'
                  };
                }
              }
            }
          } catch (err) {
            // ignore fallback error and continue
          }

          return { description: input, coords: null };
        } catch (err) {
          return { description: (typeof input === 'string' ? input : ''), coords: null };
        }
      }

      (async () => {
  let p = null;
  let d = null;
  // prefer selection objects passed from QuickBooking if present
  if (quickPickupSel) p = await resolvePlace(quickPickupSel);
  else if (quickPickup) p = await resolvePlace(quickPickup);
  if (quickDropSel) d = await resolvePlace(quickDropSel);
  else if (quickDrop) d = await resolvePlace(quickDrop);
        if (p) setPickupAddress(p);
        if (d) setDropAddress(d);

        if (quick) {
          // ensure we have a selected car to run the same flow as addbookings
          if (quickCarData) {
            setSelectedCarDetails(quickCarData);
            setCarType(quickCarData.name);
          } else if (cartypes && cartypes.length > 0) {
            // Only set default car if no car is currently selected (initial state)
            setSelectedCarDetails(cartypes[0]);
            setCarType(cartypes[0].name);
          }
          // small delay to allow state to settle, then trigger the same handler via ref
          setTimeout(() => {
            try {
              // Only trigger automatic booking flow if we have valid pickup and drop addresses
              if (p && d && p.coords && d.coords && handleGetOptionsRef && handleGetOptionsRef.current) {
                handleGetOptionsRef.current({ preventDefault: () => { } }, p, d);
              }
            } catch (e) {
              // no-op
            }
          }, 700);
        }
      })();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, cartypes, fetchPlacesAutocomplete, fetchCoordsfromPlace]);

  // Force translation of the form using settings.language if provided
  useEffect(() => {
    try {
      if (settings && settings.language && i18n && i18n.changeLanguage) {
        i18n.changeLanguage(settings.language);
      }
    } catch (e) {}
  }, [settings, i18n]);

  // Instruction text: inject English translation manually when language is English
  const instructionHtml = (i18n && i18n.language && i18n.language.toLowerCase().startsWith('en'))
    ? "<br/>Enter your pickup and drop-off address here to start your booking.<br/>Select a suggestion to confirm the address.<br/><br/>"
    : "<br/>Entrez votre adresse de départ et d'arrivée ici pour commencer votre réservation.<br /> Sélectionnez une suggestion pour confirmer l'adresse.<br/><br/>";

  const handleChange = (e) => {
    if (e.target.name === 'parcelTypeIndex') {
      setInstructionData({
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails.parcelTypes[e.target.value]
      });
    } else if (e.target.name === 'optionIndex') {
      setInstructionData({
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails.options[e.target.value]
      });
    } else if (e.target.name === 'payment_mode') {
      setPaymentMode(e.target.value);
    } else if (e.target.name === 'selectedProviderIndex') {
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    } else if (e.target.name === 'tripInstructions') {
      setTripInstructions(e.target.value);
    } else if (e.target.name === 'roundTrip') {
      setRoundTrip(e.target.value);
    } else if (e.target.name === 'bookingFlow') {
      setDeliveryWithBid(e.target.value);
    } else if (e.target.name === 'firstName') {
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    } else if (e.target.name === 'lastName') {
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    } else if (e.target.name === 'email') {
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    } else if (e.target.name === 'offerFare') {
      // Handle non-Vietnamese countries or when Vietnamese support is not needed
      if (settings?.country !== "Vietnam") {
        setOfferFare(e.target.value);
        setDisplayOfferFare(e.target.value);
      }
    } else {
      setInstructionData({ ...instructionData, [e.target.name]: e.target.value });
    }
  };

  // Vietnamese number input support for offer fare
  const handleOfferFareChange = (e) => {
    const { numericValue, displayValue } = handleVietnameseNumberInput(e.target.value, settings?.country);
    setOfferFare(numericValue.toString());
    setDisplayOfferFare(displayValue);
  };

  const [selectedDate, setSelectedDate] = useState(GetDateString());

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    setSelectedCarDetails(null);
    setCarType(DEFAULT_CAR_SELECTION);
    setBookingType('Book Now');
    setEstimateRequested(false);
    setOfferFare('');
    setDisplayOfferFare('');
  }

  useEffect(() => {
    if (auth.profile && bookingOnWait) {
      setEstimateModalStatus(false);
      dispatch(addBooking(bookingOnWait));
      setBookingOnWait(null);
      setLoading(false);
    }
  }, [auth.profile, bookingOnWait, dispatch, addBooking])

  useEffect(() => {
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'PAYMENT_PENDING') {
      if (bookingdata.booking.mainData.payment_mode === 'cash') {
        dispatch(clearBooking());
        setTempRoute(null);
        setLoading2(false);
        navigate('/bookings')
      } else {
        if (bookingdata.booking.mainData.payment_mode === 'card') {
          setLoading2(false);
          setPaymentModalStatus(true);
        } else {
          setLoading2(false);
          setWalletModalStatus(true);
        }
      }
    }
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'NEW') {
      dispatch(clearBooking());
      setTempRoute(null);
      setLoading2(false);
      navigate('/bookings')
    }
  }, [bookingdata.booking, clearBooking, dispatch, navigate]);

  const handleCarSelect = (event) => {
    console.log('🚗 Car Select Changed:', event.target.value);
    console.log('📋 Available Cartypes:', cartypes);
    console.log('🔍 Event target value type:', typeof event.target.value);
    console.log('🔍 Event target value length:', event.target.value ? event.target.value.length : 0);
    
    setCarType(event.target.value);
    let carDetails = null;
    
    if (cartypes && Array.isArray(cartypes) && cartypes.length > 0) {
      for (let i = 0; i < cartypes.length; i++) {
        if (cartypes[i].name === event.target.value) {
          carDetails = cartypes[i];
          console.log('✅ Found Car Details:', carDetails);
          
          let instObj = { ...instructionData };
          if (Array.isArray(cartypes[i].parcelTypes) && instObj.parcelTypeSelected !== cartypes[i].parcelTypes[0]) {
            instObj.parcelTypeSelected = cartypes[i].parcelTypes[0];
            instObj.parcelTypeIndex = 0;
          }
          if (Array.isArray(cartypes[i].options) && instObj.optionSelected !== cartypes[i].options[0]) {
            instObj.optionSelected = cartypes[i].options[0];
            instObj.optionIndex = 0;
          }
          setInstructionData(instObj);
          break;
        }
      }
    } else {
      console.warn('⚠️ No cartypes available or cartypes is not an array');
    }
    
    console.log('🔧 Setting Selected Car Details:', carDetails);
    setSelectedCarDetails(carDetails);
    
    // Log après setCarType pour vérifier la mise à jour
    console.log('🔍 Car Type after setCarType:', event.target.value);
  };

  const handleBookTypeSelect = (event) => {
    setBookingType(event.target.value);
    if (bookingType === 'Book Later') {
      setSelectedDate(GetDateString());
    }
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    console.log('📊 Estimate Data Changed:', estimatedata);
    console.log('🔍 Estimate Requested:', estimateRequested);
    if (estimatedata.estimate && estimateRequested) {
      console.log('✅ Estimate Received:', estimatedata.estimate);
      console.log('🔍 Estimate Structure:', JSON.stringify(estimatedata.estimate, null, 2));
      setEstimateRequested(false);
      setEstimateModalStatus(true);
    }
    if (estimatedata.estimate && estimateRequested && settings && !settings.coustomerBidPrice) {
      let price = estimatedata.estimate.estimateFare;
      let ammount = settings.coustomerBidPriceType === 'flat' ? parseFloat(price - settings.bidprice).toFixed(settings.decimal) : parseFloat(price - parseFloat(price * (settings.bidprice / 100))).toFixed(settings.decimal);
      if (ammount && ammount > 0) { setMinimumPrice(ammount) }
    }
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'customer' && ((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin')) {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")),
            'pushToken': user.pushToken ? user.pushToken : ''
          });
        }
      }
      setUsers(arr);
      let arrDrivers = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        const userLocation = user.location || user.coords;
        if ((user.usertype) && (user.usertype === 'driver') && (user.approved === true) && (user.queue === false) && (user.driverActiveStatus === true) && (userLocation) && ((user.licenseImage && settings.license_image_required) || !settings.license_image_required) && ((user.carApproved && settings.carType_required) || !settings.carType_required) && ((user.term && settings.term_required) || !settings.term_required)) {
          if ((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin' || auth.profile.usertype === 'customer') {
            arrDrivers.push({
              'uid': user.id,
              'location': userLocation,
              'carType': user.carType,
              'fleetadmin': user.fleetadmin ? user.fleetadmin : null
            });
          }
        }
      }
      setDrivers(arrDrivers);
    }
  }, [estimatedata, userdata.users, estimateRequested, settings, auth.profile.usertype, auth.profile.uid, t]);


  useEffect(() => {
    if (auth.profile.usertype && auth.profile.usertype === 'customer') {
      setUserCombo({
        'firstName': auth.profile.firstName,
        'lastName': auth.profile.lastName,
        'mobile': auth.profile.mobile,
        'email': auth.profile.email,
        'uid': auth.profile.uid,
        'pushToken': auth.profile.pushToken ? auth.profile.pushToken : ''
      })
    }
  }, [auth.profile]);


  const mobile = (userCombo && userCombo.mobile ? true : false);

  const handleGetOptions = React.useCallback(async (e, pickupOverride, dropOverride) => {
    if (e && e.preventDefault && typeof e.preventDefault === 'function') e.preventDefault();
    // allow overrides passed directly or via event.__quickPickup / __quickDrop to avoid race with setState
    const pickAddrInitial = pickupOverride || (e && e.__quickPickup) || pickupAddress;
    const dropAddrInitial = dropOverride || (e && e.__quickDrop) || dropAddress;
    
    // Early validation: ensure we have both pickup and drop addresses before proceeding
    if (!pickAddrInitial || !dropAddrInitial) {
      setCommonAlert({ open: true, msg: t('pickup_drop_location_error') || 'Veuillez sélectionner une adresse de départ et d\'arrivée' });
      return;
    }
    
    // Additional validation for address structure
    const isValidAddress = (addr) => {
      if (!addr) return false;
      if (typeof addr === 'string' && addr.trim().length > 3) return true;
      if (typeof addr === 'object' && (addr.description || addr.place_id)) return true;
      return false;
    };
    
    if (!isValidAddress(pickAddrInitial) || !isValidAddress(dropAddrInitial)) {
      setCommonAlert({ open: true, msg: t('pickup_drop_location_error') || 'Veuillez sélectionner des adresses valides' });
      return;
    }
    
    if ((settings && settings.imageIdApproval && auth.profile.usertype === 'customer' && auth.profile.verifyId) || auth.profile.usertype === 'admin' || (settings && !settings.imageIdApproval && auth.profile.usertype === 'customer') || auth.profile.usertype === 'fleetadmin') {
      if (!(settings && settings.disable_cash && (auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin')) || auth.profile.usertype === 'customer') {
        if ((auth.profile.usertype === 'customer' && parseFloat(auth.profile.walletBalance) >= 0) || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
          setEstimateRequested(true);
          if (userCombo && pickAddrInitial && dropAddrInitial && selectedCarDetails) {
            // ensure pickup/drop have coords; if not try to resolve them
            const ensureCoords = async (addr) => {
              try {
                if (!addr) return null;
                if (addr.coords && addr.coords.lat && addr.coords.lng) return addr;
                // try place_id
                if (addr.place_id) {
                  const coords = await fetchCoordsfromPlace(addr.place_id).catch(() => null);
                  if (coords && coords.lat && coords.lng) return { ...addr, coords };
                }
                // fallback: try fetchPlacesAutocomplete by description
                const results = await fetchPlacesAutocomplete(addr.description || addr, null).catch(() => null);
                if (results && results.length > 0) {
                  const r = results[0];
                  const coords = await fetchCoordsfromPlace(r.place_id).catch(() => null);
                  return { description: r.description || addr.description, place_id: r.place_id, coords: coords };
                }
                return addr;
              } catch (err) {
                return addr;
              }
            };

            const resolvedPickup = await ensureCoords(pickAddrInitial);
            const resolvedDrop = await ensureCoords(dropAddrInitial);
            if (resolvedPickup) setPickupAddress(resolvedPickup);
            if (resolvedDrop) setDropAddress(resolvedDrop);
            // if after resolving we still don't have coords, show error
            if (!(resolvedPickup && resolvedPickup.coords && resolvedPickup.coords.lat && resolvedPickup.coords.lng && resolvedDrop && resolvedDrop.coords && resolvedDrop.coords.lat && resolvedDrop.coords.lng)) {
              setCommonAlert({ open: true, msg: t('place_to_coords_error') });
              return;
            }
            // const directionService = new window.google.maps.DirectionsService();
            // directionService.route(
            //   {
            //     origin: new window.google.maps.LatLng(pickupAddress.coords.lat, pickupAddress.coords.lng),
            //     destination: new window.google.maps.LatLng(dropAddress.coords.lat, dropAddress.coords.lng),
            //     travelMode: window.google.maps.TravelMode.DRIVING
            //   },
            //   (result, status) => {
            // if (status === window.google.maps.DirectionsStatus.OK) {
            // const route = {
            //   distance_in_km:(result.routes[0].legs[0].distance.value / 1000),
            //   time_in_secs:result.routes[0].legs[0].duration.value,
            //   polylinePoints:result.routes[0].overview_polyline
            // };
            let route = null;
            try {
              route = await getDirectionsApi(resolvedPickup.coords.lat + "," + resolvedPickup.coords.lng, resolvedDrop.coords.lat + ',' + resolvedDrop.coords.lng, null);
            } catch (err) {
              console.error('getDirectionsApi Call Error', err);
              console.error('Resolved pickup/drop before directions call:', { resolvedPickup, resolvedDrop });
              setCommonAlert({ open: true, msg: t('place_to_coords_error') });
              setEstimateRequested(false);
              return;
            }
            console.log('🗺️ Route from getDirectionsApi:', route);
            setTempRoute(route);
            if (pickupAddress && dropAddress) {
              if (bookingType === 'Book Now') {
                if (mobile === true) {
                  if (Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)) {
                    setOptionModalStatus(true);
                  } else {
                    let estimateRequest = {
                      pickup: pickupAddress,
                      drop: dropAddress,
                      carDetails: selectedCarDetails,
                      instructionData: instructionData,
                      routeDetails: route
                    };
                    console.log('🚗 Estimate Request:', estimateRequest);
                    console.log('📍 Pickup Address:', pickupAddress);
                    console.log('📍 Drop Address:', dropAddress);
                    console.log('🚙 Car Details:', selectedCarDetails);
                    console.log('🛣️ Route Details:', route);
                    dispatch(getEstimate(estimateRequest));
                  }
                } else {
                  setCommonAlert({ open: true, msg: t('incomplete_user') });
                }
              } else {
                if (bookingType === 'Book Later' && selectedDate) {
                  if (MinutesPassed(selectedDate) >= 15) {
                    if (mobile === true) {
                      if (Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)) {
                        setOptionModalStatus(true);
                      } else {
                        let estimateRequest = {
                          pickup: pickupAddress,
                          drop: dropAddress,
                          carDetails: selectedCarDetails,
                          instructionData: instructionData,
                          routeDetails: route
                        };
                        dispatch(getEstimate(estimateRequest));
                      }
                    } else {
                      setCommonAlert({ open: true, msg: t('incomplete_user') });
                    }
                  } else {
                    setCommonAlert({ open: true, msg: t('past_booking_error') });
                  }
                } else {
                  setCommonAlert({ open: true, msg: t('select_proper') });
                }
              }
            } else {
              setCommonAlert({ open: true, msg: t('place_to_coords_error') })
            }
            //   }
            // }
            // )
          } else {
            setCommonAlert({ open: true, msg: t('select_proper') })
          }
        } else {
          setCommonAlert({ open: true, msg: t('wallet_balance_low') })
        }
      } else {
        setCommonAlert({ open: true, msg: t('cash_booking_false') })
      }
    } else {
      setCommonAlert({ open: true, msg: t('verifyid_error') })
    }
  }, [settings, auth.profile, userCombo, pickupAddress, dropAddress, selectedCarDetails, bookingType, mobile, getDirectionsApi, dispatch, getEstimate, setTempRoute, MinutesPassed, instructionData, selectedDate, t, fetchCoordsfromPlace, fetchPlacesAutocomplete]);

  // keep a stable ref to handleGetOptions so effects can call it without adding it to deps
  const handleGetOptionsRef = useRef(handleGetOptions);
  useEffect(() => { handleGetOptionsRef.current = handleGetOptions; }, [handleGetOptions]);

  // Ajouter des styles globaux pour l'autocomplétion et les modales
  useEffect(() => {
    const styleId = 'addBookings-global-styles';
    if (!document.getElementById(styleId)) {
      const globalStyles = document.createElement('style');
      globalStyles.id = styleId;
      globalStyles.textContent = `
        /* Z-index élevé pour les dropdowns d'autocomplétion */
        .MuiAutocomplete-popper {
          z-index: 10000 !important;
        }
        .MuiAutocomplete-listbox {
          z-index: 10000 !important;
          background-color: #2d2d2d !important;
          border: 1px solid #444 !important;
          border-radius: 8px !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;
        }
        /* Z-index pour les modales */
        .MuiModal-root {
          z-index: 9999 !important;
        }
        /* Éviter les divs vides dans l'autocomplétion */
        .MuiAutocomplete-noOptions {
          display: none !important;
        }
        /* Style pour les options d'autocomplétion - texte lisible */
        .MuiAutocomplete-option {
          background-color: #2d2d2d !important;
          color: #ffffff !important;
          border-bottom: 1px solid rgba(255,255,255,0.1) !important;
          padding: 12px 16px !important;
        }
        .MuiAutocomplete-option:hover {
          background-color: #404040 !important;
          color: #ffffff !important;
        }
        .MuiAutocomplete-option[aria-selected="true"] {
          background-color: #1976d2 !important;
          color: #ffffff !important;
        }
        /* Paper du dropdown */
        .MuiAutocomplete-paper {
          background-color: #2d2d2d !important;
          border: 1px solid #444 !important;
          border-radius: 8px !important;
        }
        
        /* Animation pour le modal */
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        
        /* Amélioration du backdrop du modal */
        .MuiBackdrop-root {
          backdrop-filter: blur(8px) !important;
          background-color: rgba(0,0,0,0.6) !important;
        }
      `;
      document.head.appendChild(globalStyles);
    }
    
    return () => {
      const existingStyles = document.getElementById(styleId);
      if (existingStyles) {
        existingStyles.remove();
      }
    };
  }, []);

  const handleWalletPayment = (e) => {
    e.preventDefault();
    let curBooking = { ...bookingdata.booking.mainData };
    if (parseFloat(curBooking.trip_cost) > parseFloat(auth.profile.walletBalance) && radioProps[payment_mode].cat === 'wallet') {
      setCommonAlert({ open: true, msg: t('wallet_balance_low') });
    } else {
      let requestedDrivers = {};
      if (settings.autoDispatch && bookingType === 'Book Now') {
        for (let i = 0; i < drivers.length; i++) {
          const driver = drivers[i];
          let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
          if (settings.convert_to_mile) {
            distance = distance / 1.609344;
          }
          if (distance < ((settings && settings.driverRadius) ? settings.driverRadius : 10) && selectedCarDetails.name === driver.carType) {
            requestedDrivers[driver['uid']] = true;
          }
        }
      }
      curBooking.prepaid = true;
      curBooking.status = 'NEW';
      curBooking.payment_mode = "wallet";
      curBooking.customer_paid = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.requestedDrivers = requestedDrivers;

      dispatch(updateBooking(curBooking));

      setTimeout(() => {
        dispatch(clearEstimate());
        setPaymentModalStatus(false);
        setWalletModalStatus(false);
        clearForm();
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings')
      }, 1500);
    }
  }

  const handleGetEstimate = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
    let estimateRequest = {
      pickup: pickupAddress,
      drop: dropAddress,
      carDetails: selectedCarDetails,
      instructionData: instructionData,
      routeDetails: tempRoute
    };
    dispatch(getEstimate(estimateRequest));
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    setLoading2(true);
    let requestedDrivers = {};
    let driverEstimates = {};

    let notfound = true;
    if (activeBookings) {
      for (let i = 0; i < activeBookings.length; i++) {
        if (activeBookings[i].payment_mode === 'wallet' && activeBookings[i].status !== 'PAID') {
          notfound = false;
          break;
        }
      }
    }

    if ((radioProps[payment_mode].cat === 'wallet' && notfound && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
      const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
      if ((otherPerson && /\S/.test(instructionData.otherPerson) && regx1.test(instructionData.otherPersonPhone) && instructionData.otherPersonPhone && instructionData.otherPersonPhone.length > 6) || !otherPerson) {
        if ((offerFare > 0 && offerFare >= parseFloat(minimumPrice)) || offerFare === '') {
          if ((radioProps[payment_mode].cat === 'wallet' && (parseFloat(auth.profile.walletBalance) >= parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare)) && !calcEst && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || (radioProps[payment_mode].cat === 'wallet' && calcEst && auth.profile.usertype === 'customer') || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
            if (settings.autoDispatch && bookingType === 'Book Now') {
              for (let i = 0; i < drivers.length; i++) {
                const driver = drivers[i];
                let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
                if (settings.convert_to_mile) {
                  distance = distance / 1.609344;
                }
                if (distance < ((settings && settings.driverRadius) ? settings.driverRadius : 10) && ((settings.carType_required && selectedCarDetails.name === driver.carType) || !settings.carType_required) && ((auth.profile.usertype === 'fleetadmin' && driver.fleetadmin === auth.profile.uid) || auth.profile.usertype !== 'fleetadmin')) {
                  requestedDrivers[driver['uid']] = true;
                  driverEstimates[driver['uid']] = { distance: distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min' };
                }
              }
              if (Object.keys(requestedDrivers).length === 0) {
                setLoading2(false);
                setCommonAlert({ open: true, msg: t('no_driver_found_alert_messege') });
                return;
              }
            }

            let bookingObject = {
              pickup: pickupAddress,
              drop: dropAddress,
              carDetails: selectedCarDetails,
              userDetails: {
                uid: userCombo.uid,
                firstName: userCombo.firstName,
                lastName: userCombo.lastName,
                mobile: userCombo.mobile,
                pushToken: userCombo.pushToken,
                email: userCombo.email
              },
              estimate: estimatedata.estimate,
              instructionData: instructionData,
              tripInstructions: tripInstructions,
              roundTrip: roundTrip === 0 ? false : true,
              tripdate: bookingType === 'Book Later' ? new Date(selectedDate).getTime() : new Date().getTime(),
              bookLater: bookingType === 'Book Later' ? true : false,
              settings: settings,
              booking_type_admin: auth.profile.usertype === 'admin' ? true : false,
              booking_type_fleetadmin: auth.profile.usertype === 'fleetadmin' ? true : false,
              fleetadmin: auth.profile.usertype === 'fleetadmin' ? auth.profile.uid : null,
              requestedDrivers: calcEst ? requestedDrivers : (optionsRequired && radioProps[payment_mode].cat === 'cash') ? requestedDrivers : (settings.prepaid && radioProps[payment_mode].cat === 'cash') ? requestedDrivers : !settings.prepaid ? requestedDrivers : requestedDrivers,
              driverEstimates: driverEstimates,
              payment_mode: (auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') ? 'cash' : radioProps[payment_mode].cat,
              booking_from_web: true,
              deliveryWithBid: auth.profile.usertype === 'customer' ? deliveryWithBid === 0 ? false : true : false,
              offerFare: (offerFare && offerFare > 0) ? offerFare : 0,
              customer_offer: (offerFare && offerFare > 0) ? offerFare : 0
            };

            if (auth.profile.usertype === 'customer' && !(auth.profile.firstName && auth.profile.lastName && auth.profile.email && auth.profile.firstName.length > 0 && auth.profile.lastName.length > 0 && auth.profile.email.length > 0)) {
              // const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
              // if ((optionsRequired && /\S/.test(instructionData.deliveryPerson) && regx1.test(instructionData.deliveryPersonPhone) && instructionData.deliveryPersonPhone && instructionData.deliveryPersonPhone.length > 6) || !optionsRequired){
              if ((profileData.firstName && profileData.firstName.length > 0 && profileData.lastName && profileData.lastName.length > 0) || (auth.profile.firstName && auth.profile.firstName.length > 0 && auth.profile.lastName && auth.profile.lastName.length > 0)) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if ((re.test(profileData.email) && !auth.profile.email) || (auth.profile.email && auth.profile.email.length > 0)) {
                  setLoading(true);
                  checkUserExists({ email: profileData.email }).then(async (res) => {
                    if (res.users && res.users.length > 0) {
                      setLoading(false);
                      alert(t('user_exists'));
                    }
                    else if (res.error) {
                      setLoading(false);
                      alert(t('email_or_mobile_issue'));
                    } else {
                      setLoading(false);
                      if (radioProps[payment_mode].cat === 'card') {
                        const paymentPacket = {
                          payment_mode: 'card',
                          customer_paid: parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                          cardPaymentAmount: parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                          discount: 0,
                          usedWalletMoney: 0,
                          cashPaymentAmount: 0,
                          promo_applied: false,
                          promo_details: null,
                          payableAmount: parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                        };
                        bookingObject['paymentPacket'] = paymentPacket;
                      }

                      const result = validateBookingObj(t, bookingObject, instructionData, otherPerson);
                      if (result.error) {
                        setLoading2(false);
                        setCommonAlert({ open: true, msg: result.msg });
                      } else {
                        profileData['uid'] = auth.profile.uid;
                        let bookingData = result.bookingObject;
                        bookingData.userDetails.firstName = profileData.firstName;
                        bookingData.userDetails.lastName = profileData.lastName;
                        bookingData.userDetails.email = profileData.email;
                        setBookingOnWait(bookingData);
                      }
                      setTimeout(() => {
                        dispatch(updateProfileWithEmail(profileData));
                      }, 200)
                    }
                  });
                } else {
                  setLoading2(false);
                  setCommonAlert({ open: true, msg: t('proper_email') })
                }
              } else {
                setLoading2(false);
                setCommonAlert({ open: true, msg: t('proper_input_name') })
              }
              // } else {
              //   setCommonAlert({ open: true, msg: t('deliveryDetailMissing') })
              // }
            } else {
              if (radioProps[payment_mode].cat === 'card') {
                const paymentPacket = {
                  payment_mode: 'card',
                  customer_paid: parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                  cardPaymentAmount: parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                  discount: 0,
                  usedWalletMoney: 0,
                  cashPaymentAmount: 0,
                  promo_applied: false,
                  promo_details: null,
                  payableAmount: parseFloat(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                };
                bookingObject['paymentPacket'] = paymentPacket;
              }
              const result = validateBookingObj(t, bookingObject, instructionData, otherPerson);
              if (result.error) {
                setLoading2(false);
                setCommonAlert({ open: true, msg: result.msg });
              } else {
                setEstimateModalStatus(false);
                dispatch(addBooking(result.bookingObject));
              }
            }
          } else {
            setLoading2(false);
            setCommonAlert({ open: true, msg: t('wallet_balance_low') });
          }
        } else {
          setLoading2(false);
          setCommonAlert({ open: true, msg: t('offer_price_greter_minimum_price') })
        }
      } else {
        setLoading2(false);
        setCommonAlert({ open: true, msg: t('otherPersonDetailMissing') })
      }
    } else {
      setLoading2(false);
      setCommonAlert({ open: true, msg: t('wallet_booking_alert') });
    }
  };

  const handleOptionModalClose = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
  };

  const handleEstimateModalClose = (e) => {
    e.preventDefault();
    setEstimateModalStatus(false);
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleWalletModalClose = (e) => {
    setTimeout(() => {
      setWalletModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    }, 1500);
  }

  const handlePaymentModalClose = (e) => {
    setTimeout(() => {
      setPaymentModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    }, 1500);
  }
  return loading2 ? (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh'
      }}
    >
      <CircularProgress />
    </Grid>
  )
    :
    (
      <div className={classes.container} ref={rootRef}>
  <Grid item xs={12} sm={12} md={8} lg={8} className={classes.formWrapper}>
          <Grid item xs={12}>
            <div style={{
              background: 'linear-gradient(135deg, rgba(212,175,55,0.1) 0%, rgba(184,134,11,0.05) 100%)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(212,175,55,0.2)',
              marginBottom: '20px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Élément décoratif de fond */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '120px',
                height: '120px',
                background: 'radial-gradient(circle, rgba(212,175,55,0.1) 0%, transparent 70%)',
                borderRadius: '50%'
              }}></div>
              
              <Typography
                variant="h4"
                style={{
                  textAlign: isRTL === 'rtl' ? 'right' : 'left',
                  fontFamily: FONT_FAMILY,
                  color: '#D4AF37',
                  fontWeight: 800,
                  fontSize: '28px',
                  marginBottom: '12px',
                  textShadow: '0 2px 10px rgba(212,175,55,0.3)',
                  position: 'relative',
                  zIndex: 1
                }}
              >
                {i18n.language?.startsWith('en') ? 'Book Your Ride' : t('add_booking_title')}
              </Typography>
              <Typography
                variant="body1"
                style={{ 
                  color: 'rgba(0,0,0,0.8)', 
                  fontSize: '16px',
                  fontFamily: FONT_FAMILY,
                  lineHeight: 1.5,
                  position: 'relative',
                  zIndex: 1,
                  fontWeight: 500
                }}
                dangerouslySetInnerHTML={{ __html: instructionHtml }}
              />
            </div>
          </Grid>
          <div className={classes.container1} style={{
            background: 'linear-gradient(145deg, #0a0a0a 0%, #1a1a1a 50%, #0f0f0f 100%)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Élément décoratif doré */}
            <div style={{
              position: 'absolute',
              top: '-20px',
              left: '-20px',
              width: '100px',
              height: '100px',
              background: 'radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%)',
              borderRadius: '50%'
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              right: '-30px',
              width: '150px',
              height: '150px',
              background: 'radial-gradient(circle, rgba(184,134,11,0.06) 0%, transparent 70%)',
              borderRadius: '50%'
            }}></div>
            <Grid container spacing={2} >
              <Grid item xs={12} >
                {users && auth.profile.usertype && auth.profile.usertype !== 'customer' ?
                  <UsersCombo
                    className={classes.items}
                    placeholder={t('select_user')}
                    users={users}
                    value={userCombo}
                    onChange={(event, newValue) => {
                      setUserCombo(newValue);
                    }}
                  />
                  : null}
              </Grid>
              <Grid item xs={12} >
                <GoogleMapsAutoComplete
                  variant={"outlined"}
                  placeholder={t('pickup_location')}
                  value={pickupAddress}
                  className={[classes.items, classes.textFieldFull].join(' ')}
                  onChange={(value) => setPickupAddress(value)}
                  onInputChange={(raw)=>{/* no-op here; selection handled by onChange */}}
                  style={{background: 'transparent'}}
                  // make input text white to match dark form
                  inputTextColor={colors.WHITE}
                  startAdornment={<span style={{display:'inline-flex', alignItems:'center', marginRight:8}}><svg width="16" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#D4AF37"/><circle cx="12" cy="9" r="2.5" fill="#fff"/></svg></span>}
                />
                {/* Confirmation badge for selected pickup address */}
                {pickupAddress && pickupAddress.description ? (
                  <Typography variant="caption" style={{display:'block', marginTop:6, color: colors.CARD_LABEL}}>
                    {t('pickup_location') + ': '}{pickupAddress.description}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={12} >
                <GoogleMapsAutoComplete
                  placeholder={t('drop_location')}
                  variant={"outlined"}
                  value={dropAddress}
                  className={[classes.items, classes.textFieldFull].join(' ')}
                  onChange={(value) => setDropAddress(value)}
                  onInputChange={(raw)=>{}}
                  style={{background: 'transparent'}}
                  inputTextColor={colors.WHITE}
                  startAdornment={<span style={{display:'inline-flex', alignItems:'center', marginRight:8}}><svg width="16" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#D4AF37"/><circle cx="12" cy="9" r="2.5" fill="#fff"/></svg></span>}
                />
                {/* Confirmation badge for selected drop address */}
                {dropAddress && dropAddress.description ? (
                  <Typography variant="caption" style={{display:'block', marginTop:6, color: colors.CARD_LABEL}}>
                    {t('drop_location') + ': '}{dropAddress.description}
                  </Typography>
                ) : null}
              </Grid>
              
              {/* Carte avec itinéraire */}
              <Grid item xs={12} sm={6} >
                {cartypes ?
                  <div className={classes.carTypeContainer}>
                                    <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={carType}
                    onChange={handleCarSelect}
                    variant="outlined"
                      fullWidth
                    style={{ backgroundColor: colors.BLACK, textAlign: isRTL === 'rtl' ? 'right' : 'left', }}
                    className={carType === DEFAULT_CAR_SELECTION ? classes.inputdimmed : classes.input}
                    // Debug: log la valeur actuelle du Select
                    onOpen={() => console.log('🔍 Select opened, current carType:', carType)}
                    sx={{
                      // On dark form background make select text white for contrast
                      color: colors.WHITE,
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: MAIN_COLOR,
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: { backgroundColor: '#ffffff', color: colors.BLACK }
                      }
                    }}

                  >
                    <MenuItem dense={true} value={DEFAULT_CAR_SELECTION} key={DEFAULT_CAR_SELECTION} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', width: '100%', justifyContent: 'flex-start', paddingLeft: 10, fontFamily: FONT_FAMILY }}>
                      {t('select_car')}
                    </MenuItem>
                      {
                        cartypes.sort((a, b) => a.pos - b.pos).map((car, idx) => {
                          // If cartype is an object with details, render a rich MenuItem like QuickBooking
                          if (car && typeof car === 'object' && car.name) {
                            const rate = car.rate_per_unit_distance;
                            const minFare = car.min_fare;
                            return (
                              <MenuItem dense={true} key={car.name || idx} value={car.name} sx={{ display: 'flex', gap: 1, alignItems: 'center', direction: isRTL === 'rtl' ? 'rtl' : 'ltr', paddingLeft: 1, fontFamily: FONT_FAMILY }}>
                                {car.image ? <img src={car.image} alt={car.name} style={{ width: 72, height: 50, objectFit: 'cover', borderRadius: 8, marginRight: 12 }} /> : <div style={{ width: 72, height: 50, background: '#222', borderRadius: 8, marginRight: 12 }} />}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: isRTL === 'rtl' ? 'flex-end' : 'flex-start' }}>
                                  <Typography style={{ color: colors.BLACK, fontWeight: 700 }}>{t(getLangKey(car.name))}</Typography>
                                  <Typography style={{ color: colors.Button_Primary, fontSize: 13 }}>{settings && settings.swipe_symbol === false ? `${settings.symbol}${formatAmount(rate, settings.decimal || 2, settings.country)}` : `${formatAmount(rate, settings.decimal || 2, settings.country)}${settings && settings.symbol ? settings.symbol : '€'}`}/{settings && settings.convert_to_mile ? t('mile') || 'mile' : t('km') || 'km'}</Typography>
                                  <Typography style={{ color: colors.BLACK, fontSize: 12 }}>{t('min_fare')}: <span style={{ color: colors.Button_Primary }}>{settings && settings.swipe_symbol === false ? `${settings.symbol}${formatAmount(minFare, settings.decimal || 2, settings.country)}` : `${formatAmount(minFare, settings.decimal || 2, settings.country)}${settings && settings.symbol ? settings.symbol : '€'}`}</span></Typography>
                                  {car.extra_info ? <Typography style={{ color: colors.BLACK, fontSize: 12 }}>{t('extra_info')}: <span style={{ color: colors.BLACK }}>{car.extra_info}</span></Typography> : null}
                                </div>
                              </MenuItem>
                            );
                          }
                          // fallback simple string item
                          return (
                            <MenuItem dense={true} key={car || idx} value={car} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', width: '100%', justifyContent: 'flex-start', paddingLeft: 10, fontFamily: FONT_FAMILY, color: colors.BLACK }}>
                                {car}
                              </MenuItem>
                          );
                        })
                      }
                  </Select>
                  </div>
                  : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <Select
                  id="booking-type-native"
                  value={bookingType}
                  onChange={handleBookTypeSelect}
                  className={classes.input}
                  style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}
                  sx={{
                    // ensure readable text on dark background
                    color: colors.WHITE,
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: MAIN_COLOR,
                    },
                  }}
                  variant="outlined"
                  fullWidth
                  inputProps={{ 'aria-label': 'Without label' }}
                  disabled
                >
                  <MenuItem dense key={"Book Later"} value={"Book Later"} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', width: '100%', justifyContent: 'flex-start', paddingLeft: 10, fontFamily: FONT_FAMILY }}>
                    {t('book_later')}
                  </MenuItem>
                </Select>
              </Grid>
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={6} >
                  <TextField
                    InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                    id="datetime-local"
                    label={t('booking_date_time')}
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    className={[isRTL === 'rtl' ? classes.inputRtl : classes.commonInputStyle, classes.textField, classes.textFieldFull].join(" ")}
                    InputProps={{
                      className: classes.input,
                      style: { textAlignLast: isRTL === 'rtl' ? 'end' : 'start' }
                    }}
                    value={selectedDate}
                    onChange={onDateChange}
                  />
                </Grid>
                : null}
                
                {/* Carte avec itinéraire - Placée avant le bouton de confirmation */}
                {pickupAddress && dropAddress && (
                  <Grid item xs={12} style={{ marginTop: 20, marginBottom: 20 }}>
                    <div style={{ 
                      padding: 20, 
                      backgroundColor: colors.LandingPage_Background, 
                      borderRadius: 8,
                      border: `1px solid ${colors.BORDER_COLOR || '#ddd'}`
                    }}>
                      <Typography variant="h6" style={{ 
                        color: colors.WHITE, 
                        marginBottom: 15, 
                        fontFamily: FONT_FAMILY,
                        textAlign: 'center'
                      }}>
                        Itinéraire de votre trajet
                      </Typography>
                      <RouteMap 
                        pickup={pickupAddress} 
                        drop={dropAddress}
                      />
                    </div>
                  </Grid>
                )}
                
                {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={6} >
                  <Button
                    size="lg"
                    onClick={handleGetOptions}
                    variant="contained"
                    className={classes.ctaButton}
                    style={{ width: '100%' }}
                  >
                    <i className="fas fa-car" style={isRTL === 'rtl' ? { marginLeft: 5 } : { marginRight: 5 }} />
                    {t('book')}
                  </Button>
                </Grid>
                :
                <Grid item xs={12} >
                  <Button
                    size="lg"
                    onClick={handleGetOptions}
                    variant="contained"
                    className={classes.ctaButton}
                    style={{ width: '100%' }}
                  >
                    <i className="fas fa-car" style={isRTL === 'rtl' ? { marginLeft: 5 } : { marginRight: 5 }} />
                    {t('book')}
                  </Button>
                </Grid>
              }
            </Grid>
          </div>
        </Grid>
        

        
        <Modal
          disablePortal
          open={optionModalStatus}
          onClose={handleOptionModalClose}
          className={classes.modal}
          container={() => rootRef.current}
          style={{ zIndex: 9999 }}
        >
          <Grid container spacing={2} className={classes.paperDark}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
              {selectedCarDetails && selectedCarDetails.parcelTypes ?
                <FormControl component="fieldset">
                  <FormLabel component="legend" style={{ fontFamily: FONT_FAMILY, }}>{t('parcel_types')}</FormLabel>
                  <RadioGroup name="parcelTypeIndex" value={instructionData.parcelTypeIndex} onChange={handleChange}>
                    {selectedCarDetails.parcelTypes.map((element, index) =>
                      <FormControlLabel key={element.description} value={index} control={<Radio />} label={<Typography className={classes.typography}>{settings.swipe_symbol === false ? settings.symbol + ' ' + formatAmount(element.amount, settings.decimal, settings.country) + ' - ' + t(getLangKey(element.description)) : formatAmount(element.amount, settings.decimal, settings.country) + ' ' + settings.symbol + ' - ' + t(getLangKey(element.description))}</Typography>} />
                    )}
                  </RadioGroup>
                </FormControl>
                : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
              {selectedCarDetails && selectedCarDetails.options ?
                <FormControl component="fieldset">
                  <FormLabel component="legend" style={{ fontFamily: FONT_FAMILY, }}>{t('options')}</FormLabel>
                  <RadioGroup name="optionIndex" value={instructionData.optionIndex} onChange={handleChange}>
                    {selectedCarDetails.options.map((element, index) =>
                      <FormControlLabel key={element.description} value={index} control={<Radio />} label={<Typography className={classes.typography}>{settings.swipe_symbol === false ? settings.symbol + ' ' + formatAmount(element.amount, settings.decimal, settings.country) + ' - ' + t(getLangKey(element.description)) : formatAmount(element.amount, settings.decimal, settings.country) + ' ' + settings.symbol + ' - ' + t(getLangKey(element.description))}</Typography>} />
                    )}
                  </RadioGroup>
                </FormControl>
                : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
              <Button onClick={handleOptionModalClose} variant="outlined" className={classes.secondaryButton}>
                {t('cancel')}
              </Button>
              <Button onClick={handleGetEstimate} variant="contained" className={classes.ctaButton} style={isRTL === 'rtl' ? { marginRight: 10 } : { marginLeft: 10 }}>
                {t('get_estimate')}
              </Button>
            </Grid>
          </Grid>
        </Modal>
        <Modal
          disablePortal
          open={estimateModalStatus}
          onClose={handleEstimateModalClose}
          className={classes.modal}
          container={() => rootRef.current}
          style={{ 
            zIndex: 9999,
            backdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(0,0,0,0.5)'
          }}
          BackdropProps={{
            style: {
              backdropFilter: 'blur(12px)',
              backgroundColor: 'rgba(0,0,0,0.5)'
            }
          }}
        >
          <div className={classes.modalContent} style={{ 
            background: 'linear-gradient(145deg, rgba(20,20,25,0.95) 0%, rgba(30,30,35,0.98) 100%)', 
            padding: '24px 20px', 
            borderRadius: '16px', 
            maxWidth: '480px', 
            width: '90%',
            maxHeight: '85vh',
            overflowY: 'auto',
            color: '#fff', 
            boxShadow: '0px 16px 48px rgba(0,0,0,0.3), 0px 6px 20px rgba(0,0,0,0.2)', 
            backdropFilter: 'saturate(150%) blur(12px)',
            border: '1px solid rgba(255,255,255,0.1)',
            zIndex: 9999,
            position: 'relative',
            animation: 'modalSlideIn 0.3s ease-out'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '14px' }}>
              <div style={{ 
                width: '6px', 
                height: '24px', 
                background: `linear-gradient(180deg, ${MAIN_COLOR} 0%, ${SECONDORY_COLOR} 100%)`, 
                borderRadius: '3px', 
                marginRight: '12px' 
              }}></div>
              <Typography variant="h5" style={{ 
                fontWeight: 600, 
                color: '#fff', 
                fontFamily: FONT_FAMILY,
                fontSize: '20px',
                letterSpacing: '0.5px'
              }}>
                {i18n.language?.startsWith('en') ? 'Booking Confirmation' : (t('confirm_booking') || 'Confirmation')}
              </Typography>
            </div>

            <div style={{ color: '#fff' }}>
              {/* Trip Details Summary */}
              {pickupAddress && dropAddress ? (
                <div style={{
                  background: 'rgba(255,255,255,0.03)',
                  padding: '12px',
                  borderRadius: '10px',
                  marginBottom: '16px',
                  border: '1px solid rgba(255,255,255,0.08)'
                }}>
                  <Typography style={{ 
                    fontSize: '12px', 
                    color: 'rgba(255,255,255,0.7)',
                    fontFamily: FONT_FAMILY,
                    marginBottom: '10px',
                    fontWeight: 600,
                    letterSpacing: '1px'
                  }}>
                    {i18n.language?.startsWith('en') ? 'TRIP DETAILS' : 'TRAJET'}
                  </Typography>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#4CAF50',
                        boxShadow: '0 0 6px #4CAF5050'
                      }}></div>
                      <Typography style={{ 
                        fontSize: '13px', 
                        color: '#fff',
                        fontFamily: FONT_FAMILY,
                        lineHeight: 1.3
                      }}>
                        {typeof pickupAddress === 'object' ? pickupAddress.description : pickupAddress}
                      </Typography>
                    </div>
                    
                    <div style={{ 
                      width: '2px', 
                      height: '16px', 
                      background: 'linear-gradient(180deg, #4CAF50 0%, #FF5722 100%)',
                      marginLeft: '3px',
                      opacity: 0.6
                    }}></div>
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#FF5722',
                        boxShadow: '0 0 6px #FF572250'
                      }}></div>
                      <Typography style={{ 
                        fontSize: '13px', 
                        color: '#fff',
                        fontFamily: FONT_FAMILY,
                        lineHeight: 1.3
                      }}>
                        {typeof dropAddress === 'object' ? dropAddress.description : dropAddress}
                      </Typography>
                    </div>
                  </div>
                </div>
              ) : null}
              
              <div style={{
                '& .MuiTypography-root': {
                  fontSize: '12px !important',
                  lineHeight: '1.4 !important'
                },
                '& .MuiTypography-h6': {
                  fontSize: '14px !important',
                  fontWeight: '600 !important'
                },
                '& .MuiTypography-body1': {
                  fontSize: '12px !important'
                },
                '& .MuiTypography-body2': {
                  fontSize: '11px !important'
                }
              }}>
                <BookingModalBody
                classes={classes}
                instructionData={instructionData}
                handleChange={handleChange}
                tripInstructions={tripInstructions}
                roundTrip={roundTrip}
                auth={auth}
                profileData={profileData}
                settings={settings}
                deliveryWithBid={deliveryWithBid}
                otherPerson={otherPerson}
                setOtherPerson={setOtherPerson}
                minimumPrice={minimumPrice}
                offerFare={offerFare}
                displayOfferFare={displayOfferFare}
                handleOfferFareChange={handleOfferFareChange}
                  estimate={estimatedata.estimate}
                />
              </div>
            </div>            {/* Price summary */}
            {showEst && settings && settings.hasOwnProperty("bookingFlow") && (settings.bookingFlow === "0" || settings.bookingFlow === "2") ? null :
              <div style={{ 
                marginTop: '12px', 
                marginBottom: '12px', 
                textAlign: isRTL === 'rtl' ? 'right' : 'left',
                background: 'rgba(255,255,255,0.05)',
                padding: '12px',
                borderRadius: '10px',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <Typography style={{ 
                  fontSize: '11px', 
                  color: 'rgba(255,255,255,0.6)', 
                  fontFamily: FONT_FAMILY,
                  marginBottom: '4px',
                  fontWeight: 500,
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>
                  {i18n.language?.startsWith('en') ? 'total' : t('total')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Typography style={{ 
                    fontSize: '24px', 
                    fontWeight: 700, 
                    color: MAIN_COLOR, 
                    fontFamily: FONT_FAMILY,
                    textShadow: `0 0 14px ${MAIN_COLOR}30`
                  }}>
                    {settings && settings.swipe_symbol === false ? `${settings.symbol} ${estimatedata.estimate ? formatAmount(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare, settings.decimal, settings.country) : ''}` : `${estimatedata.estimate ? formatAmount(estimatedata.estimate.fareCost || estimatedata.estimate.estimateFare, settings.decimal, settings.country) : ''} ${settings ? settings.symbol : ''}`}
                  </Typography>
                  <div style={{
                    background: `linear-gradient(45deg, ${MAIN_COLOR}20, ${SECONDORY_COLOR}20)`,
                    padding: '3px 8px',
                    borderRadius: '14px',
                    border: `1px solid ${MAIN_COLOR}40`,
                    fontSize: '10px',
                    color: MAIN_COLOR,
                    fontWeight: 600
                  }}>
                    {i18n.language?.startsWith('en') ? 'Estimate' : 'Estimation'}
                  </div>
                </div>
              </div>
            }

            {auth.profile.usertype === 'customer' ?
              <div style={{ 
                marginTop: '12px', 
                textAlign: isRTL === 'rtl' ? 'right' : 'left',
                background: 'rgba(255,255,255,0.03)',
                padding: '12px',
                borderRadius: '10px',
                border: '1px solid rgba(255,255,255,0.08)'
              }}>
                <FormControl component="fieldset" style={{ width: '100%' }}>
                  <FormLabel 
                    component="legend" 
                    style={{ 
                      fontFamily: FONT_FAMILY, 
                      color: '#fff',
                      fontSize: '13px',
                      fontWeight: 600,
                      marginBottom: '8px',
                      display: 'block'
                    }}
                  >
                    {t('payment_mode')}
                  </FormLabel>
                  <RadioGroup 
                    name="payment_mode" 
                    value={payment_mode} 
                    onChange={handleChange} 
                    style={{ 
                      gap: '2px',
                      flexDirection: radioProps.length > 3 ? 'row' : 'column',
                      flexWrap: 'wrap'
                    }}
                  >
                    {radioProps.map((element, index) =>
                      <FormControlLabel 
                        key={element.cat} 
                        value={index} 
                        control={
                          <Radio 
                            sx={{ 
                              color: 'rgba(255,255,255,0.6)', 
                              '&.Mui-checked': { color: MAIN_COLOR },
                              '&:hover': { backgroundColor: `${MAIN_COLOR}20` },
                              padding: '4px',
                              '& .MuiSvgIcon-root': { fontSize: '18px' }
                            }} 
                          />
                        } 
                        label={
                          <Typography style={{ 
                            color: '#fff',
                            fontFamily: FONT_FAMILY,
                            fontSize: '13px',
                            fontWeight: 500,
                            lineHeight: 1.2
                          }}>
                            {element.label}
                          </Typography>
                        }
                        style={{
                          margin: '1px 0',
                          padding: '4px 8px',
                          borderRadius: '6px',
                          transition: 'all 0.2s ease',
                          minWidth: radioProps.length > 3 ? '48%' : 'auto',
                          '&:hover': {
                            backgroundColor: 'rgba(255,255,255,0.05)'
                          }
                        }}
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </div>
              : null}

            <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'flex-end' }}>
              {loading ?
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  padding: '16px'
                }}>
                  <CircularProgress 
                    size={28} 
                    style={{ color: MAIN_COLOR }}
                  />
                  <Typography style={{ 
                    marginLeft: '10px', 
                    color: 'rgba(255,255,255,0.8)',
                    fontFamily: FONT_FAMILY,
                    fontSize: '14px'
                  }}>
                    {t('processing') || 'Traitement...'}
                  </Typography>
                </div>
                :
                <>
                  <Button 
                    onClick={handleEstimateModalClose} 
                    variant="outlined" 
                    style={{
                      borderColor: 'rgba(255,255,255,0.3)',
                      color: 'rgba(255,255,255,0.9)',
                      padding: '10px 20px',
                      borderRadius: '10px',
                      fontFamily: FONT_FAMILY,
                      fontWeight: 600,
                      textTransform: 'none',
                      fontSize: '14px',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: 'rgba(255,255,255,0.6)',
                        backgroundColor: 'rgba(255,255,255,0.1)'
                      }
                    }}
                  >
                    {t('cancel')}
                  </Button>
                  <Button 
                    onClick={confirmBooking} 
                    variant="contained" 
                    style={{
                      background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                      color: '#000',
                      padding: '10px 28px',
                      borderRadius: '10px',
                      fontFamily: FONT_FAMILY,
                      fontWeight: 700,
                      textTransform: 'none',
                      fontSize: '14px',
                      boxShadow: '0 6px 20px rgba(255, 215, 0, 0.4)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 8px 24px rgba(255, 215, 0, 0.6)'
                      }
                    }}
                  >
                    {t('book_now')}
                  </Button>
                </>
              }
            </div>
          </div>
        </Modal>

        <Modal
          disablePortal
          open={walletModalStatus}
          onClose={handleWalletModalClose}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <Grid container spacing={2} className={classes.paper}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '20px' }}>
              <Typography style={{ fontWeight: 'bolder', marginBottom: 10 }}>
                {t('payment')}
              </Typography>
              {bookingdata && bookingdata.booking ?
                <Typography color={"primary"} style={{ fontSize: 30 }}>
                  {(settings.swipe_symbol === false ? settings.symbol + formatAmount(bookingdata.booking.mainData.trip_cost, settings.decimal, settings.country) : formatAmount(bookingdata.booking.mainData.trip_cost, settings.decimal, settings.country) + settings.symbol)}
                </Typography>
                : null}
              <Typography >
                {t('use_wallet_balance') + " " + (settings.swipe_symbol === false ? settings.symbol + formatAmount(auth.profile.walletBalance, settings.decimal, settings.country) : formatAmount(auth.profile.walletBalance, settings.decimal, settings.country) + settings.symbol) + ")"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button onClick={handleWalletModalClose} variant="outlined" className={classes.secondaryButton}>
                {t('cancel')}
              </Button>
              <Button variant="contained" className={classes.ctaButton} style={{ marginLeft: 10, backgroundColor: colors.GREEN, color: colors.BLACK }} onClick={handleWalletPayment}>
                {t('paynow_button')}
              </Button>
            </Grid>
          </Grid>
        </Modal>
        <Modal
          disablePortal
          open={paymentModalStatus}
          onClose={handlePaymentModalClose}
          className={classes.modal}
          container={() => rootRef.current}
          style={{ zIndex: 9999 }}
        >
          <Grid container spacing={2} className={classes.paper}>
            {providers && selectedProvider && bookingdata && bookingdata.booking ?
              <form action={selectedProvider.link} method="POST">
                <input type='hidden' name='order_id' value={bookingdata.booking.booking_id} />
                <input type='hidden' name='amount' value={bookingdata.booking.mainData.trip_cost} />
                <input type='hidden' name='currency' value={settings.code} />
                <input type='hidden' name='product_name' value={t('bookingPayment')} />
                <input type='hidden' name='first_name' value={auth.profile.firstName} />
                <input type='hidden' name='last_name' value={auth.profile.lastName} />
                <input type='hidden' name='quantity' value={1} />
                <input type='hidden' name='cust_id' value={bookingdata.booking.mainData.customer} />
                <input type='hidden' name='mobile_no' value={bookingdata.booking.mainData.customer_contact} />
                <input type='hidden' name='email' value={bookingdata.booking.mainData.customer_email} />
                <input type='hidden' name='platform'  value={'web'} />
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '20px' }}>
                  <FormControl fullWidth>
                    <FormLabel component="legend">{t('payment')}</FormLabel>
                    <Select
                      id="selectedProviderIndex"
                      name="selectedProviderIndex"
                      value={selectedProviderIndex}
                      label={t('payment')}
                      onChange={handleChange}
                      style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      {providers.map((provider, index) =>
                        <MenuItem key={provider.name} value={index}><img style={{ height: 24, margin: 7 }} src={icons[provider.name]} alt={provider.name} /> </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Button onClick={handlePaymentModalClose} variant="outlined" className={classes.secondaryButton}>
                    {t('cancel')}
                  </Button>
                  <Button variant="contained" className={classes.ctaButton} type="submit" style={{ marginLeft: 10 }} onClick={handlePaymentModalClose}>
                    {t('paynow_button')}
                  </Button>
                </Grid>
              </form>
              : null}
          </Grid>
        </Modal>
        <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
        <AlertDialog open={estimatedata.error.flag} onClose={handleEstimateErrorClose}>{estimatedata.error.msg}</AlertDialog>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
    );
}
